import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card p-0" }
const _hoisted_2 = { class: "ms-body" }
const _hoisted_3 = { class: "ms-page" }
const _hoisted_4 = { class: "ms-section" }
const _hoisted_5 = { class: "ms-field" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "ms-field" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ms-field" }
const _hoisted_11 = { class: "ms-section" }
const _hoisted_12 = {
  key: 0,
  class: "ms-gathered-box ms-field"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ms-field" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "ms-lock-note"
}
const _hoisted_18 = { class: "ms-field" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ms-section" }
const _hoisted_22 = { class: "row g-3" }
const _hoisted_23 = { class: "col-md-6 ms-field mb-0" }
const _hoisted_24 = { class: "col-md-6 ms-field mb-0" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "ms-footer" }
const _hoisted_27 = {
  key: 0,
  class: "ms-success-banner mb-3"
}
const _hoisted_28 = ["href"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "table table-bordered mb-2" }
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "d-flex justify-content-end gap-2 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_loading = _resolveComponent("loading")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "ms-header" }, [
      _createElementVNode("h1", { class: "ms-title" }, "Manual Scheduling"),
      _createElementVNode("p", { class: "ms-subtitle" }, "Create a confirmed visit directly for a participant and standardized patient.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "ms-section-label" }, [
            _createElementVNode("span", null, "Visit Details")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[20] || (_cache[20] = _createElementVNode("label", {
              for: "partner_id",
              class: "ms-label"
            }, "Partner", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "partner_id",
              class: "form-select",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getPartnerData && _ctx.getPartnerData(...args))),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.partner_id) = $event))
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("option", { value: null }, "Select a partner…", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: partner.id,
                  value: partner.id
                }, _toDisplayString(partner.slug), 9, _hoisted_6))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.partner_id]
            ]),
            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "ms-hint" }, "Partners without remaining seats will not be listed.", -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[23] || (_cache[23] = _createElementVNode("label", {
              for: "scenario_id",
              class: "ms-label"
            }, "Scenario", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "scenario_id",
              class: "form-select",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getScenarioData && _ctx.getScenarioData(...args))),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.scenario_id) = $event)),
              disabled: !_ctx.partner_id
            }, [
              _cache[22] || (_cache[22] = _createElementVNode("option", { value: null }, "Select a scenario…", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarios, (scenario) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: scenario.id,
                  value: scenario.id
                }, _toDisplayString(scenario.id) + " — " + _toDisplayString(scenario.patient_name), 9, _hoisted_9))
              }), 128))
            ], 40, _hoisted_8), [
              [_vModelSelect, _ctx.scenario_id]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[24] || (_cache[24] = _createElementVNode("label", {
              for: "job_number",
              class: "ms-label"
            }, "Job Number", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "job_number",
              class: "form-control ms-readonly",
              disabled: "",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.job_number) = $event)),
              placeholder: "Populated from partner / scenario combination"
            }, null, 512), [
              [_vModelText, _ctx.job_number]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "ms-section-label" }, [
            _createElementVNode("span", null, "Participants")
          ], -1)),
          (_ctx.has_gathered)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[27] || (_cache[27] = _createElementVNode("p", { class: "ms-gathered-title" }, [
                  _createElementVNode("i", { class: "fas fa-link me-1" }),
                  _createTextVNode(" Gathered Curriculum Link "),
                  _createElementVNode("span", { class: "ms-gathered-optional" }, "(optional)")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "gathered_user",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selected_gathered_user) = $event)),
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onGatheredUserChange && _ctx.onGatheredUserChange(...args)))
                }, [
                  _cache[26] || (_cache[26] = _createElementVNode("option", { value: null }, "None — no gathered link", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gathered_users, (gu) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: gu.gathered_user_id + '-' + gu.gathered_group_id,
                      value: gu
                    }, _toDisplayString(gu.first_name) + " " + _toDisplayString(gu.last_name) + " (" + _toDisplayString(gu.email) + ") — Group " + _toDisplayString(gu.gathered_group_id), 9, _hoisted_13))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selected_gathered_user]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _cache[30] || (_cache[30] = _createElementVNode("label", {
              for: "p_user_id",
              class: "ms-label"
            }, "Participant", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "p_user_id",
              class: "form-select",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.p_user_id) = $event)),
              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.isSubmitAvailable && _ctx.isSubmitAvailable(...args))),
              disabled: _ctx.selected_gathered_user !== null || !_ctx.scenario_id
            }, [
              _cache[28] || (_cache[28] = _createElementVNode("option", { value: null }, "Select a participant…", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.p_users, (p_user) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: p_user.id,
                  value: p_user.id
                }, _toDisplayString(p_user.first_name) + " " + _toDisplayString(p_user.last_name) + " (" + _toDisplayString(p_user.email) + ")", 9, _hoisted_16))
              }), 128))
            ], 40, _hoisted_15), [
              [_vModelSelect, _ctx.p_user_id]
            ]),
            (_ctx.selected_gathered_user !== null)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _cache[29] || (_cache[29] = [
                  _createElementVNode("i", { class: "fas fa-lock" }, null, -1),
                  _createTextVNode(" Locked to gathered selection — choose \"None\" above to unlock. ")
                ])))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[32] || (_cache[32] = _createElementVNode("label", {
              for: "sp_user_id",
              class: "ms-label"
            }, "Standardized Patient", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "sp_user_id",
              class: "form-select",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sp_user_id) = $event)),
              onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.isSubmitAvailable && _ctx.isSubmitAvailable(...args))),
              disabled: !_ctx.scenario_id
            }, [
              _cache[31] || (_cache[31] = _createElementVNode("option", { value: null }, "Select a standardized patient…", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sp_users, (sp_user) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: sp_user.id,
                  value: sp_user.id
                }, _toDisplayString(sp_user.first_name) + " " + _toDisplayString(sp_user.last_name) + " (" + _toDisplayString(sp_user.email) + ")", 9, _hoisted_20))
              }), 128))
            ], 40, _hoisted_19), [
              [_vModelSelect, _ctx.sp_user_id]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "ms-section-label" }, [
            _createElementVNode("span", null, "Schedule")
          ], -1)),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[34] || (_cache[34] = _createElementVNode("label", {
                for: "date",
                class: "ms-label"
              }, "Date", -1)),
              _createVNode(_component_Datepicker, {
                id: "date",
                class: "ms-datepicker",
                "lower-limit": new Date(),
                placeholder: "Select a date…",
                modelValue: _ctx.date,
                "onUpdate:modelValue": [
                  _cache[11] || (_cache[11] = ($event: any) => ((_ctx.date) = $event)),
                  _ctx.isSubmitAvailable
                ]
              }, null, 8, ["lower-limit", "modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[36] || (_cache[36] = _createElementVNode("label", {
                for: "time",
                class: "ms-label"
              }, [
                _createTextVNode("Time "),
                _createElementVNode("span", { class: "ms-hint d-inline ms-0" }, "(Eastern Time)")
              ], -1)),
              _withDirectives(_createElementVNode("select", {
                id: "time",
                class: "form-select",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.time) = $event)),
                onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.isSubmitAvailable && _ctx.isSubmitAvailable(...args)))
              }, [
                _cache[35] || (_cache[35] = _createElementVNode("option", { value: null }, "Select a time…", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.time_options, (time_option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: time_option.value,
                    value: time_option.value
                  }, _toDisplayString(time_option.label), 9, _hoisted_25))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.time]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _cache[42] || (_cache[42] = _createElementVNode("p", { class: "ms-hint text-center mb-3" }, " All sessions are scheduled in Eastern Time and marked as confirmed upon creation. ", -1)),
          (_ctx.scheduled_url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _cache[39] || (_cache[39] = _createElementVNode("i", { class: "fas fa-check-circle me-2" }, null, -1)),
                _cache[40] || (_cache[40] = _createElementVNode("span", null, "Visit scheduled — ", -1)),
                _createElementVNode("a", {
                  href: '/#/visit/' + _ctx.visit_id,
                  target: "_blank",
                  class: "ms-success-action"
                }, _cache[38] || (_cache[38] = [
                  _createElementVNode("i", { class: "fas fa-arrow-up-right-from-square" }, null, -1),
                  _createTextVNode(" Open link ")
                ]), 8, _hoisted_28),
                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "ms-success-divider" }, "|", -1)),
                _createElementVNode("button", {
                  class: "ms-success-action ms-copy-btn",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.copyUrl && _ctx.copyUrl(...args)))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.url_copied ? 'fas fa-check' : 'fas fa-copy')
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(_ctx.url_copied ? 'Copied!' : 'Copy link'), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-primary ms-submit-btn",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.openConfirmModal && _ctx.openConfirmModal(...args))),
            disabled: !_ctx.submit_available
          }, " Schedule Visit ", 8, _hoisted_29)
        ])
      ])
    ]),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.show_confirm_modal,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.show_confirm_modal) = $event)),
      "allow-close": ""
    }, {
      header: _withCtx(() => _cache[43] || (_cache[43] = [
        _createTextVNode("Confirm Visit Details")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.show_confirm_modal = false))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, "Continue")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_30, [
          _createElementVNode("tbody", null, [
            _cache[54] || (_cache[54] = _createElementVNode("tr", { class: "ms-confirm-section" }, [
              _createElementVNode("td", { colspan: "2" }, "Visit")
            ], -1)),
            _createElementVNode("tr", null, [
              _cache[44] || (_cache[44] = _createElementVNode("th", { class: "ms-confirm-th" }, "Partner", -1)),
              _createElementVNode("td", null, _toDisplayString(_ctx.selected_partner?.slug), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[45] || (_cache[45] = _createElementVNode("th", { class: "ms-confirm-th" }, "Scenario", -1)),
              _createElementVNode("td", null, _toDisplayString(_ctx.selected_scenario?.id) + " – " + _toDisplayString(_ctx.selected_scenario?.patient_name), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[46] || (_cache[46] = _createElementVNode("th", { class: "ms-confirm-th" }, "Job Number", -1)),
              _createElementVNode("td", null, _toDisplayString(_ctx.job_number ?? '—'), 1)
            ]),
            _cache[55] || (_cache[55] = _createElementVNode("tr", { class: "ms-confirm-section" }, [
              _createElementVNode("td", { colspan: "2" }, "People")
            ], -1)),
            _createElementVNode("tr", null, [
              _cache[48] || (_cache[48] = _createElementVNode("th", { class: "ms-confirm-th" }, "Participant", -1)),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(_ctx.selected_p_user?.first_name) + " " + _toDisplayString(_ctx.selected_p_user?.last_name) + " ", 1),
                _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("small", _hoisted_31, _toDisplayString(_ctx.selected_p_user?.email), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[50] || (_cache[50] = _createElementVNode("th", { class: "ms-confirm-th" }, "SP", -1)),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(_ctx.selected_sp_user?.first_name) + " " + _toDisplayString(_ctx.selected_sp_user?.last_name) + " ", 1),
                _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("small", _hoisted_32, _toDisplayString(_ctx.selected_sp_user?.email), 1)
              ])
            ]),
            (_ctx.selected_gathered_user)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                  _cache[51] || (_cache[51] = _createElementVNode("th", { class: "ms-confirm-th" }, "Gathered", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.selected_gathered_user.first_name) + " " + _toDisplayString(_ctx.selected_gathered_user.last_name) + " — Group " + _toDisplayString(_ctx.selected_gathered_user.gathered_group_id), 1)
                ]))
              : _createCommentVNode("", true),
            _cache[56] || (_cache[56] = _createElementVNode("tr", { class: "ms-confirm-section" }, [
              _createElementVNode("td", { colspan: "2" }, "Schedule")
            ], -1)),
            _createElementVNode("tr", null, [
              _cache[52] || (_cache[52] = _createElementVNode("th", { class: "ms-confirm-th" }, "Date", -1)),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatted_date), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[53] || (_cache[53] = _createElementVNode("th", { class: "ms-confirm-th" }, "Time (Eastern)", -1)),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatted_time), 1)
            ])
          ])
        ]),
        _cache[57] || (_cache[57] = _createElementVNode("p", { class: "ms-hint mb-0" }, "This visit will be marked as confirmed. Please review before continuing.", -1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}